const StarIcon = ({ filled = false, size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill={filled ? "currentColor" : "#e6e6e6"}
  >
    <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
);

const ReviewCard = ({ item }) => (
  <div className="review_item">
    <div className="review_item_top">
      <div className="review_avatar">{item.initials || "R"}</div>
      <div className="review_meta">
        <h4>{item.name}</h4>
        <span>{item.city}</span>
      </div>
      <div className="review_rating">
        <div className="review_stars">
          {[1, 2, 3, 4, 5].map((star) => (
            <span key={star} className={star <= item.rating ? "filled" : ""}>
              <StarIcon filled={star <= item.rating} size={14} />
            </span>
          ))}
        </div>
      </div>
    </div>
    <p className="review_text">{item.review}</p>
    <span className="review_date">{item.formatted_date}</span>
  </div>
);

export default ReviewCard;
